<script setup lang="ts">
import { RouterView } from 'vue-router';

import HubSettingsDrawer from '@/components/HubSettingsDrawer.vue';
import { useHubSettingsDrawer } from '@/composables/useHubSettingsDrawer';

const { settingsDrawerOpen } = useHubSettingsDrawer();
</script>

<template>
	<div class="flex min-h-dvh w-full flex-col">
		<RouterView />
		<HubSettingsDrawer v-model:open="settingsDrawerOpen" />
	</div>
</template>
